import offsetParent from './offset-parent';

var isBodyOffset = function (element) { return (offsetParent(element) === element.ownerDocument.body); };

export default isBodyOffset;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/is-body-offset.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/is-body-offset.js
// module chunks = 3